import React from 'react';
import s from './TOIPLoadingPlaceholder.scss';

function TOIPLoadingPlaceholder() {
  return (
    <div className={s.jitter_holder}>
      <div className={`${s.thumb_slot} ${s.animation}`} />
      <div className={s.content_slot}>
        <div className={`${s.first_line} ${s.animation}`} />
        <div className={`${s.second_line} ${s.animation}`} />
        <div className={`${s.third_line} ${s.animation}`} />
        <div className={`${s.third_line} ${s.animation}`} />
      </div>
    </div>
  );
}

export default TOIPLoadingPlaceholder;
